import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { TagsProps } from 'components/uiKit/CheckableTag'
import CheckableTag from 'components/uiKit/CheckableTag'

const FieldTag = <V extends string>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<TagsProps<V>, V[]>) => {
  const handleChange = useCallback((value: V[]) => onChange({ name, value }), [name, onChange])

  return <CheckableTag {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldTag) as typeof FieldTag
